export function locationPath(locationId: string, section = ''): string {
  const suffix = section.replace(/^\//, '');
  return suffix ? `/locations/${locationId}/${suffix}` : `/locations/${locationId}`;
}

/** Keep the same section when switching sites. Drop a record id so a ticket does not follow. */
export function locationSiblingPath(pathname: string, fromId: string, toId: string): string {
  const prefix = `/locations/${fromId}`;
  const rest = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : '';
  const parts = rest.split('/').filter(Boolean);
  const last = parts[parts.length - 1];
  if (last && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(last)) {
    parts.pop();
  }
  return locationPath(toId, parts.join('/'));
}
